import React from "react";
import { useEffect } from "react";
import api from "../../utils/api";
import { useState } from "react";
import AdminServiceRequestTable from "../../components/ServiceRequests/Admin/AdminServiceRequestTable";
import Actions from "../../components/ServiceRequests/Admin/Actions";
import { toast } from "react-toastify";
import { getUser } from "../../utils/localStorage";
import { useHistory } from "react-router-dom";

import useDebouncedEffect from "../../hoc/useDebouncedEffect";
import ConfirmHandholderAssignmentModal from "../../components/ServiceRequests/Handholder/ConfirmHandholderAssignmentModal";
import Spinner from "../../common/Spinner/Spinner";

const PAGE_SIZE = 10;

export default function AdminServiceRequestsContainer(props) {
	const [isLoading, setIsLoading] = useState(false);

	const [serviceRequests, setServiceRequests] = useState([]);
	const [selectedServiceRequests, setSelectedServiceRequests] = useState([]);

	const [handholderList, setHandholderList] = useState([]);
	const [serviceNameList, setServiceNameList] = useState([]);
	const [selectedServiceNameList, setSelectedServiceNameList] = useState([]);

	const [selectedHandholder, setSelectedHandholder] = useState(null);
	const [clearCount, setClearCount] = useState(0);

	const [
		showUnassignedServiceRequests,
		toggleUnassignedServiceRequests,
	] = useState(false);

	// const [selectedFollowupDate, setSelectedFollowupDate] = useState([]);

	const [showFailedPayments, toggleFailedPayments] = useState(false);

	const [searchTerm, setSearchTerm] = useState("");
	const [searchFilter, setSearchFilter] = useState(null);
	const [filterError, setFilterError] = useState(false);

	const [tableInstance, setTableInstance] = useState(null);

	const [serviceRequestStatusList, setServiceRequestStatusList] = useState(
		[]
	);
	const [followUpDateTo, setFollowUpDateTo] = useState("");
	const [followUpDateFrom, setFollowUpDateFrom] = useState("");

	const [
		selectedServiceRequestStatusList,
		setSelectedServiceRequestStatusList,
	] = useState([]);

	const [paymentStatusList, setPaymentStatusList] = useState([
		{ checked: false, label: "Credit", id: "Credit", code: "Credit" },
		{ checked: false, label: "Failed", id: "Failed", code: "Failed" },
	]);

	const [selectedPaymentStatus, setSelectedPaymentStatus] = useState([]);

	const [
		MovedToSPMStatusOptions,
		setMovedToSPMStatusOptions,
	] = useState([
		{
			value: "all",
			label: "All",
		},
		{
			value: "yes",
			label: "Yes",
		},
		{
			value: "no",
			label: "No",
		},
	]);
	const [
		selectedMovedToSPMStatus,
		setSelectedMovedToSPMStatus,
	] = useState({
		value: "all",
		label: "All",
	});

	/*Service Filter logic change states*/
	const [serviceNameListForFilter, setServiceNameListForFilter] = useState([]);
	const [selectedServiceNameListForFilter, setSelectedServiceNameListForFilter] = useState([]);
	/*Service Filter logic change states end*/

	/*Package Filter states*/
	const [packageNameListForFilter, setPackageNameListForFilter] = useState([]);
	const [selectedPackageNameListForFilter, setSelectedPackageNameListForFilter] = useState([]);
	const [
		servicesThroughPackageOptions,
		setservicesThroughPackageOptions,
	] = useState([
		{
			value: "all",
			label: "All",
		},
		{
			value: "yes",
			label: "Yes",
		},
		{
			value: "no",
			label: "No",
		},
	]);
	const [
		selectedServicesThroughPackageOption,
		setSelectedServicesThroughPackageOption,
	] = useState({
		value: "all",
		label: "All",
	});
	/*Package Filter States end*/


	/**
	 * pagination states
	 */
	const [pages, setPages] = useState(0);
	const [pageSize, setPageSize] = useState(10);
	// const [pageSize, setPageSize] = useState(10);
	const history = useHistory();
	const [bulkAssignServiceRequest, setBulkAssignServiceRequest] = useState(
		[]
	);
	const [numberOfServices, setNumberOfServices] = useState(0);
	const [
		selectedServiceRequestsHasHandholder,
		setSelectedServiceRequestsHasHandholder,
	] = useState(false);


	const [count, setCount ] = useState(0);

	useEffect(() => {
		let temp = [];
		selectedServiceRequests.map((e) => {
			if (temp.includes(e.sEmailAddress) === false) {
				temp.push(e.sEmailAddress);
			}
		});
		if (temp.length) {
			api.assignHandholder({ email_ids: temp }).then((d) => {
				setBulkAssignServiceRequest(d.data);

				let numServices = 0;
				Object.entries(d.data).map(([key, value]) => {
					if (typeof value === "object") {
						numServices += value.length;
						value.map((x) => {
							if (x.refHH !== null) {
								setSelectedServiceRequestsHasHandholder(true);
							}
						});
					}
				});
				setNumberOfServices(numServices);
			});
		} else {
			setSelectedServiceRequestsHasHandholder(false);
			setBulkAssignServiceRequest([]);
			setNumberOfServices(0);
		}
	}, [selectedServiceRequests]);
	
	useEffect(() => {
		/**
		 * fetch master list of all handholders in the system
		 */
		if (!getUser()) {
			history.push("/login");
		}
		api.getAllHandholders().then(({ data }) => {
			const hh = Object.keys(data).map((hh) => ({
				value: hh,
				label: hh,
			}));
			setHandholderList(hh);
		});

		api.getDisableFalseServiceRequestsNames({
			bDisableService:false
		}).then(({ data }) => {
			const serviceReqNames = Object.keys(data).map((idx) => {
				return {
					checked: selectedServiceNameList.includes(
						data[idx].sServiceCode
					),
					label: data[idx].sServiceName,
					id: data[idx].id,
					code: data[idx].sServiceCode,
				};
			});
			setServiceNameList(serviceReqNames);
			const serviceReqNamesForFilter = Object.keys(data).map((idx) => {
				return {
					label: data[idx].sServiceName,
					id: data[idx].id,
					value: data[idx].sServiceCode,
				};
			});
			setServiceNameListForFilter(serviceReqNamesForFilter);
		});

		api.getAllPackageCatalogues().then(({ data }) => 
		{
			const packageNamesForFilter = Object.keys(data).map((idx) => {
				return {
					label: data[idx].sPackageOfferTitle,
					id: data[idx].id,
					value: data[idx].id,
				};
			});
			setPackageNameListForFilter(packageNamesForFilter);
		});

		api.getAllServiceRequestsStatus().then(({ data }) => {
			const serviceReqStatus = Object.keys(data).map((idx) => {
				return {
					checked: selectedServiceRequestStatusList.includes(
						data[idx].id
					),
					label: data[idx].sSRState,
					id: data[idx].sSRState,
					code: data[idx].sSRState,
				};
			});
			setServiceRequestStatusList(serviceReqStatus);
		});
	}, []);
	// useDebouncedEffect(
	// 	() => {
	// 		getAllServiceRequests(tableInstance);
	// 	},
	// 	1000,
	// 	[
	// 		searchTerm,
	// 		selectedPaymentStatus,
	// 		selectedFollowupDate,
	// 		selectedServiceRequestStatusList,
	// 		showUnassignedServiceRequests,
	// 		selectedServiceNameList,

	// 		showFailedPayments,
	// 		tableInstance,
	// 	]
	// );

	// const [navigationClicked, setNavigationClicked] = useState(false);
	const fetchServiceRequests = (instance, flag) => {
		// setNavigationClicked(flag);
		getAllServiceRequests(instance, flag);
	};
	const getAllServiceRequests = async (instance, flag = false) => {
		if (!instance) return;
		if (!tableInstance) setTableInstance(instance);
		try {
			const { page } = instance.state ?? { page: 0 };
			const pageSize = instance.state.pageSize;


			let searchFilterParams = null;
			let sortParams = null;
			if (searchFilter) {
				const { value } = searchFilter;
				searchFilterParams = { [value]: searchTerm };
			}
			if (instance.state.sorted.length > 0) {
				const { id, desc } = instance.state.sorted[0];
				sortParams = { column: id, desc };
			}
			const unassigned = showUnassignedServiceRequests;
			//const serviceRequestList = selectedServiceNameList;
			
			let serviceRequestListtemp2 = [];
			selectedServiceNameListForFilter.map((e) => {
				serviceRequestListtemp2.push(e.value);
			});
			const serviceRequestList=serviceRequestListtemp2

			let packageListtemp = [];
			selectedPackageNameListForFilter.map((e) => {
				if(e.value!="*")
				{
					packageListtemp.push(e.value);
				}
			});
			const PackageList=packageListtemp
			const ServicesThroughPackage = selectedServicesThroughPackageOption;

			const failedPayments = showFailedPayments;
			const statusList = selectedServiceRequestStatusList;
			const paymentStatus = selectedPaymentStatus;
			const movedToSPMStatus = selectedMovedToSPMStatus;
			const fromDate = followUpDateFrom;
			const toDate = adjustedToDate(followUpDateTo);
			setIsLoading(true);
			const { data } = await api.getAllServiceRequests(
				page + 1,
				pageSize,
				fromDate,
				toDate,
				paymentStatus,
				statusList,
				unassigned,
				serviceRequestList,
				failedPayments,
				movedToSPMStatus,
				ServicesThroughPackage,	
				PackageList,		
				searchFilterParams,
				sortParams,
				flag
			);
			setIsLoading(false);
			const { results, count } = data;

			const totalPages = (count - 1) / pageSize + 1;
			setServiceRequests(results);
			setCount(count);
			setPages(Math.floor(totalPages));
			setPageSize(pageSize);

		} catch (error) {
			console.error(error);
		}
	};

	const handleHandholderAssigned = () => {
		if (!selectedHandholder) {
			toast("Please select a handholder.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		if (selectedServiceRequests.length === 0) return;
		const serviceRequests = selectedServiceRequests.map(
			(sr) => sr.nResourceInstanceId
		);
		const handholder = selectedHandholder.value;
		const payload = {
			HH: handholder,
			nResourceInstanceIds: serviceRequests,
		};
		setIsLoading(true);
		api.assignHandholder(payload)
			.then((response) => {
				setSelectedHandholder(null);
				setSelectedServiceRequests([]);
				getAllServiceRequests(tableInstance,true);

				if (response.status == 207) {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.INFO,
					});
				} else {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}
			})
			.catch((error) => {
				toast("Something went wrong. Contact webadmin support.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			});
		setIsLoading(false);
	};
	const handleUnAssignHandholder = () => {
		const serviceRequests = selectedServiceRequests.map(
			(sr) => sr.nResourceInstanceId
		);
		const payload = { HH: null, nResourceInstanceIds: serviceRequests };
		api.assignHandholder(payload)
			.then((response) => {
				setSelectedHandholder(null);
				setSelectedServiceRequests([]);
				getAllServiceRequests(tableInstance,true);

				if (response.status == 207) {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.INFO,
					});
				} else {
					toast(String(response.data.message), {
						autoClose: 5000,
						type: toast.TYPE.SUCCESS,
					});
				}
			})
			.catch((error) => {
				toast("Something went wrong. Contact webadmin support.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			});
	};
	const downloadOutboundUploadLogs = () => {
		const data = api
			.downloadOutboundLogs()
			.then(({ data }) => {
				window.open(data["generated_file"], "_self");
			})
			.catch((error) => {
				toast("Server error.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			});
	};
	const [
		outboundCallingReportFile,
		setOutboundCallingReportFile,
	] = useState();
	const uploadOutboundReport = () => {
		if (!outboundCallingReportFile) return;
		var formData = new FormData();

		formData.append(
			"outbound_report",
			outboundCallingReportFile,
			outboundCallingReportFile.name
		);
		setIsLoading(true);
		const data = api
			.generateOutboundCallingLog(formData)
			.then(({ data }) => {
				window.open(data["fOutputFile"], "_self");
			})
			.then(() => {
				setIsLoading(false);
			})
			.catch((error) => {
				toast("Server error.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
				setIsLoading(false);
			});
	};
	const onOutboundUpload = (e) => {
		console.log("files", e.target.files);
		setOutboundCallingReportFile(e.target.files[0]);
	};
	const generateCallingReport = () => {
		const serviceRequests = selectedServiceRequests.map(
			(sr) => sr.nResourceInstanceId
		);
		api.generateCallingReport()
			.then((response) => {
				console.log(response);
				toast(response["data"]["details"], {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
			})
			.catch((error) => {
				toast("Something went wrong. Contact webadmin support.", {
					autoClose: 5000,
					type: toast.TYPE.ERROR,
				});
			});
	};
	const handleSearchInputChange = ({ target }) => {
		const { value } = target;
		setSearchTerm(value);
		if (searchFilter === null) {
			setFilterError(true);
		}
	};
	const handleSearchClick = async () => {
		/*if (searchTerm.length > 0 && searchFilter) {
			const { value } = searchFilter;
			const { data } = await api.searchServiceRequests({
				[value]: searchTerm,
			});
			const { results, count } = data;
			const totalPages = (count - 1) / pageSize + 1;
			setServiceRequests(results);
			setPages(Math.floor(totalPages));
		}
		if (searchTerm.length === 0) {
			getAllServiceRequests(tableInstance);
		}*/
		getAllServiceRequests(tableInstance);
	};
	const handleClearFilterSearch = () => {		
		setSearchTerm("");
		setSelectedMovedToSPMStatus({
			value: "all",
			label: "All",
		});
		setSelectedServicesThroughPackageOption({
			value: "all",
			label: "All",
		});
		setSelectedServiceRequestStatusList([]);
		setSelectedPaymentStatus([]);
		setSelectedServiceNameListForFilter([]);
		setSelectedPackageNameListForFilter([]);
		let tempPaymentStatus = paymentStatusList.map((x) => {
			x.checked = false;
			return x;
		});
		setPaymentStatusList(tempPaymentStatus);
		
		let tempSrStatus = serviceRequestStatusList.map((x) => {
			x.checked = false;
			return x;
		});
		setServiceRequestStatusList(tempSrStatus);
		
		setSearchTerm("");		
		setFollowUpDateFrom("");
		setFollowUpDateTo("");
		setSearchFilter(null);
		setClearCount(clearCount+1);	
	};

	useEffect(() => {
		if(clearCount>0)
		{
			getAllServiceRequests(tableInstance);
		}		
	}, [clearCount]);

	const toggleAll = () => {
		let temp = selectedServiceNameList;
		if (selectedServiceNameList.length != serviceNameList.length) {
			let tempSR = serviceNameList.map((e) => {
				if (!temp.includes(e.code)) {
					temp = temp.concat(e.code);
					e.checked = true;
				}
				return e;
			});
			setSelectedServiceNameList(temp);
			setServiceNameList(tempSR);
			getAllServiceRequests(tableInstance);
		} else {
			let tempSR = serviceNameList.map((e) => {
				e.checked = false;

				return e;
			});
			setSelectedServiceNameList([]);
			setServiceNameList(tempSR);
			getAllServiceRequests(tableInstance);
		}
	};

	const toggleSelection = (e) => {
		let temp = selectedServiceNameList;

		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempSR = serviceNameList.map((x) => {
				if (x.code === e) {
					x.checked = true;
				}
				return x;
			});
			setServiceNameList(tempSR);
			setSelectedServiceNameList(temp);
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempSR = serviceNameList.map((x) => {
				if (x.code === e) {
					x.checked = false;
				}
				return x;
			});
			setServiceNameList(tempSR);
			setSelectedServiceNameList(temp);
			// getAllServiceRequests(tableInstance);
		}
	};

	const toggleStatusSelection = (e) => {
		let temp = selectedServiceRequestStatusList;

		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempSrStatus = serviceRequestStatusList.map((x) => {
				if (x.id == e) {
					x.checked = true;
				}
				return x;
			});
			setServiceRequestStatusList(tempSrStatus);
			setSelectedServiceRequestStatusList(temp);
			// getAllServiceRequests(tableInstance)
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempSrStatus = serviceRequestStatusList.map((x) => {
				if (x.id == e) {
					x.checked = false;
				}
				return x;
			});
			setServiceRequestStatusList(tempSrStatus);
			setSelectedServiceRequestStatusList(temp);
			// getAllServiceRequests(tableInstance);
		}
	};

	const togglePaymentStatus = (e) => {
		let temp = selectedPaymentStatus;

		if (!temp.includes(e)) {
			temp = temp.concat(e);
			let tempPaymentStatus = paymentStatusList.map((x) => {
				if (x.id == e) {
					x.checked = true;
				}
				return x;
			});
			setPaymentStatusList(tempPaymentStatus);
			setSelectedPaymentStatus(temp);
			// getAllServiceRequests(tableInstance)
		} else {
			let idx = temp.indexOf(e);
			temp.splice(idx, 1);
			let tempPaymentStatus = paymentStatusList.map((x) => {
				if (x.id == e) {
					x.checked = false;
				}
				return x;
			});
			setPaymentStatusList(tempPaymentStatus);
			setSelectedPaymentStatus(temp);
			// getAllServiceRequests(tableInstance);
		}
	};

	
	const [
		showConfirmHandholderAssignmentModal,
		setShowConfirmHandholderAssignmentModal,
	] = useState(false);
	const toggleConfirmHandholderAssignmentModal = () => {
		// if (!selectedHandholder) {
		//   toast("Please select a handholder.", {
		//     autoClose: 5000,
		//     type: toast.TYPE.ERROR,
		//   });
		//   return;
		// }
		if (selectedServiceRequests.length == 0) {
			toast("Please select service requests.", {
				autoClose: 5000,
				type: toast.TYPE.ERROR,
			});
			return;
		}
		setShowConfirmHandholderAssignmentModal(
			!showConfirmHandholderAssignmentModal
		);
	};

	const adjustedToDate = (date) => {
		let toDateAdjusted;
		if (date) {
			toDateAdjusted = new Date(date);

			toDateAdjusted = new Date(
				toDateAdjusted.setTime(
					toDateAdjusted.getTime() + 24 * 60 * 60 * 1000 - 1000
				)
			);
		}
		return toDateAdjusted;
	};

	/*Callbacks for service filter */
	const toggleAllForFilter = () => 
	{
		let temp =[];
		
		if (selectedServiceNameListForFilter.length != serviceNameListForFilter.length && selectedServiceNameListForFilter.length!=(serviceNameListForFilter.length+1)) 
		{
			if(selectedServiceNameListForFilter.includes({label: "All", value: "*"}))
			{
				temp = selectedServiceNameListForFilter;
			}
			else{
				temp =[{label: "All", value: "*"}];
			}

			let tempSR = serviceNameListForFilter.map((e) => 
			{
				if (!temp.includes(e)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedServiceNameListForFilter(temp);
			setServiceNameListForFilter(tempSR);
			getAllServiceRequests(tableInstance);
		} 
		else
		{
			setSelectedServiceNameListForFilter([]);
			getAllServiceRequests(tableInstance);
		}
	};

	const toggleSelectionForFilter = (e) => {
		setSelectedServiceNameListForFilter(e);
	};
	/* Callbacks for service filter */

	/*Callbacks for Package filter */
	const toggleAllForPackageFilter = () => 
	{
		let temp =[];
		
		if (selectedPackageNameListForFilter.length != packageNameListForFilter.length && selectedPackageNameListForFilter.length!=(packageNameListForFilter.length+1)) 
		{
			if(selectedPackageNameListForFilter.includes({label: "All", value: "*"}))
			{
				temp = selectedPackageNameListForFilter;
			}
			else{
				temp =[{label: "All", value: "*"}];
			}

			let tempSR = packageNameListForFilter.map((e) => 
			{
				if (!temp.includes(e)) 
				{
					temp = temp.concat(e);
				}
				return e;
			});
			setSelectedPackageNameListForFilter(temp);
			setPackageNameListForFilter(tempSR);
			getAllServiceRequests(tableInstance);
		} 
		else
		{
			setSelectedPackageNameListForFilter([]);
			getAllServiceRequests(tableInstance);
		}
	};

	const toggleSelectionForPackageFilter = (e) => {
		setSelectedPackageNameListForFilter(e);
	};
	/* Callbacks for Package filter */

	return (
		<div className={`${isLoading && "set-opacity"}`}>
			{isLoading && <Spinner className="center-screen" />}

			<Actions
				downloadOutboundUploadLogs={downloadOutboundUploadLogs}
				uploadOutboundReport={uploadOutboundReport}
				onOutboundUpload={onOutboundUpload}
				useForSPM={false}
				selectedServiceRequestsHasHandholder={
					selectedServiceRequestsHasHandholder
				}
				numberOfServices={numberOfServices}
				selectedHandholder={selectedHandholder}
				onSelectHandholder={setSelectedHandholder}
				selectedServiceRequests={selectedServiceRequests}
				onAssignHandholder={handleHandholderAssigned}
				onUnAssignHandholder={handleUnAssignHandholder}
				generateCallingReport={generateCallingReport}
				toggleConfirmHandholderAssignmentModal={
					toggleConfirmHandholderAssignmentModal
				}
				showConfirmHandholderAssignmentModal={
					showConfirmHandholderAssignmentModal
				}
				handholderList={handholderList}
				toggleUnassignedServiceRequests={() => {
					if (!tableInstance) return;

					toggleUnassignedServiceRequests(
						!showUnassignedServiceRequests
					);
				}}
				showUnassignedServiceRequests={showUnassignedServiceRequests}
				onSearchInputChange={handleSearchInputChange}
				searchFilter={searchFilter}
				onSearchFilterChange={(option) => {
					setFilterError(false);
					setSearchFilter(option);
				}}
				onSearchClicked={handleSearchClick}
				onClearFilterSearch={handleClearFilterSearch}
				searchTerm={searchTerm}
				filterError={filterError}
				ServiceRequestList={serviceNameList}
				serviceNameListForFilter={serviceNameListForFilter}
				selectedServiceNameListForFilter={selectedServiceNameListForFilter}
				toggleAllForFilter={toggleAllForFilter}
				toggleSelectionForFilter={toggleSelectionForFilter}
				packageNameListForFilter={packageNameListForFilter}
				selectedPackageNameListForFilter={selectedPackageNameListForFilter}
				toggleAllForPackageFilter={toggleAllForPackageFilter}
				toggleSelectionForPackageFilter={toggleSelectionForPackageFilter}
				servicesThroughPackageOptions={servicesThroughPackageOptions}
				selectedServicesThroughPackageOption={selectedServicesThroughPackageOption}
				onServicesThroughPackageOptionChange={(option) => {setSelectedServicesThroughPackageOption(option);}}
				toggleSelection={toggleSelection}
				toggleAll={toggleAll}
				toggleFailedPayments={() => {
					if (!tableInstance) return;
					toggleFailedPayments(!showFailedPayments);
				}}
				showFailedPayments={showFailedPayments}
				serviceRequestStatusList={serviceRequestStatusList}
				toggleStatusSelection={toggleStatusSelection}
				paymentStatusList={paymentStatusList}
				togglePaymentStatus={togglePaymentStatus}

				MovedToSPMStatusOptions={MovedToSPMStatusOptions}
				selectedMovedToSPMStatus={selectedMovedToSPMStatus}
				onMovedToPSMStatusChange={(option) => {
					setSelectedMovedToSPMStatus(option);
				}}

				/**
				 * follow up dates filters
				 */
				count={count}
				showCount={true}
				followUpDateTo={followUpDateTo}
				followUpDateFrom={followUpDateFrom}
				setFollowUpDateTo={setFollowUpDateTo}
				setFollowUpDateFrom={setFollowUpDateFrom}
			/>

			<AdminServiceRequestTable
				data={serviceRequests}
				// page={currentPage}
				selectedServiceRequests={selectedServiceRequests}
				onSelectServiceRequest={setSelectedServiceRequests}
				onFetchServiceRequests={fetchServiceRequests}
				pages={pages}
				pageSize={pageSize}
			/>
			<div>
				<ConfirmHandholderAssignmentModal
					numberOfServices={numberOfServices}
					bulkAssignServiceRequest={bulkAssignServiceRequest}
					isOpen={showConfirmHandholderAssignmentModal}
					toggleModal={toggleConfirmHandholderAssignmentModal}
					selectedServiceRequests={selectedServiceRequests}
					selectedHandholder={selectedHandholder}
					// handleHandholderAssigned={handleHandholderAssigned}
				/>
			</div>
		</div>
	);
}
